import classNames from 'classnames'
import React from 'react'

interface ExpandIconProps {
	size?: 'sm' | 'md' | 'lg'
}

const ExpandIcon: React.FC<ExpandIconProps> = ({ size = 'sm' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		className={classNames({
			'w-2.5 h-2.5': size === 'sm',
			'w-3.5 h-3.5': size === 'md',
			'w-5 h-5': size === 'lg',
		})}
		fill="none"
		viewBox="0 0 7 11"
	>
		<path
			className="fill-brand-secondary"
			d="M.993 2.167A.83.83 0 112.167.993l3.92 3.92a.83.83 0 010 1.174l-3.92 3.92a.827.827 0 01-1.174 0 .83.83 0 010-1.174L4.326 5.5.993 2.167z"
		/>
	</svg>
)

export default ExpandIcon
